export default __webpack_public_path__ + "static/media/tPro1.9a0279a1.jpg";